import { matchPath } from 'react-router';

import {
  fittingType,
  selectDate,
  selectShop,
  selectStylist,
  selectTreatment,
  treatmentCategory,
  aboutYou,
  complete,
  completedBooking,
  review,
  apiError,
  signUpModal,
  manageAppointments,
  cancelAppointmentModal,
  cancelAppointmentConfirmation,
  selectProduct,
} from './analytics-json-data';

const analyticsJsonDataMap = {
  '/appointments/:serviceName/fitting-type': fittingType,
  '/appointments/:serviceName/products': selectProduct,
  '/appointments/:serviceName/shops': selectShop,
  '/appointments/:serviceName/partners': selectStylist,
  '/appointments/:serviceName/select-treatment': selectTreatment,
  '/appointments/:serviceName/treatment-category': treatmentCategory,
  '/appointments/:serviceName/select-date': selectDate,
  '/appointments/:serviceName/about-you': aboutYou,
  '/appointments/:serviceName/review': review,
  '/appointments/:serviceName/bookings': complete,
  '/appointments/:serviceName/completed-booking': completedBooking,
  '/appointments/manage-appointments': manageAppointments,

  apiError,

  'sign-up.modal': signUpModal,
  'cancel-appointment.modal': cancelAppointmentModal,
  'cancel-appointment.confirmation': cancelAppointmentConfirmation,

  '/appointments/:serviceName/edit-shop': review,
  '/appointments/:serviceName/edit-partner': review,
  '/appointments/:serviceName/edit-date': review,
  '/appointments/:serviceName/edit-your-details': review,
  '/appointments/:serviceName/edit-question-answers/:section': review,
};

export const getAnalyticsJsonDataMap = (path) => {
  const entry = Object.entries(analyticsJsonDataMap).find(([key]) =>
    matchPath(path, {
      path: key,
    }),
  );
  return entry ? JSON.parse(JSON.stringify(entry[1])) : undefined;
};
